import React from 'react';
import './TariffRates.css';

const TariffRates = () => {
  const tariffData = [
    {
      type: 'ONE WAY DROP',
      sedan: '₹14/Km',
      suv: '₹19/Km',
      innova: '₹20/Km'
    },
    {
      type: 'ROUND WAY TRIP',
      sedan: '₹13/Km',
      suv: '₹18/Km',
      innova: '₹19/Km'
    },
    {
      type: 'DRIVER BATA',
      sedan: '₹400',
      suv: '₹400',
      innova: '₹400'
    }
  ];

  return (
    <div id="tariff-section" className="tariff-rates">
      <div className="tariff-container">
        <h2 className="tariff-title">ONE WAY DROP TAXI TARIFF</h2>
        
        <div className="tariff-table-container">
          <table className="tariff-table">
            <thead>
              <tr className="table-header">
                <th className="header-cell">Types of Vehicles</th>
                <th className="header-cell">SEDAN</th>
                <th className="header-cell">SUV</th>
                <th className="header-cell">INNOVA</th>
              </tr>
            </thead>
            <tbody>
              {tariffData.map((row, index) => (
                <tr key={index} className="table-row">
                  <td className="row-label">{row.type}</td>
                  <td className="row-data">{row.sedan}</td>
                  <td className="row-data">{row.suv}</td>
                  <td className="row-data">{row.innova}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TariffRates;